import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { AppStateFacade } from '@app-state';
import { PageMetadataRegistry } from '@app/router';
import { AccessCode } from '@models';
import { extractDashboardOptions } from '@pages/monitoring/dashboard/widgets/generics/services';
import {
    permissionMapFactory,
    resourceKeys,
} from '@pages/monitoring/monitoring.constants';
import { restrictedUrlTree } from '@pages/shared/restricted-access';

import {
    map,
    share,
    take,
} from 'rxjs/operators';

@Injectable()
export class MonitoringGuard implements CanActivate {
    constructor(
        private _appState: AppStateFacade,
        private _router: Router,
        private _pageRegistry: PageMetadataRegistry,
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        // get the entities count for monitoring dashboard layout
        const options = extractDashboardOptions(route.paramMap);
        const keys = resourceKeys();
        const permissionMap$ = permissionMapFactory(this._appState)
            .pipe(
                take(1),
                share(),
            );

        const hasAccess$ = permissionMap$
            .pipe(
                map(permission => {
                    if (!permission[options.resource]) {
                        const resource = keys.find(key => permission[key]);
                        const page = this._pageRegistry.findByRoute(state.url);

                        if (!resource) {
                            return restrictedUrlTree(this._router, {
                                page,
                                code: AccessCode.PermissionRequired,
                            });
                        }

                        return this._router.createUrlTree([
                            '/monitoring',
                            resource,
                        ]);
                    }

                    return permission[options.resource];
                }),
            );


        return hasAccess$;
    }
}
